// 備忘：圖片的位子：themes\frontend\src\assets\site\ 。@代表themes\frontend\src\路徑下 // 另外頁尾的menu(slot
name="menu")位子在：themes\frontend\partials\site\footer.htm

<template>
  <div class="site-footer">
    <div class="site-footer__sitemap">
      <div class="container w1680">
        <div class="pure-g">
          <div class="item pure-u-1-2 pure-u-md-1-3 pure-u-lg-1-5">
            <a class="link-cardly" href="https://hr.kymco.com/" title="KYMCO 徵才" target="_blank">
              <img alt="KYMCO 徵才" src="@/assets/site/sitemap-1.png" />
            </a>
          </div>
          <div class="item pure-u-1-2 pure-u-md-1-3 pure-u-lg-1-5">
            <a class="link-cardly" href="https://www.kymco.com.tw/static/loveCar/oil/index.html" title="精品油品/原廠油品"
              target="_blank">
              <img alt="精品油品/原廠油品" src="@/assets/site/sitemap-2.png" />
            </a>
          </div>
          <div class="item pure-u-1-2 pure-u-md-1-3 pure-u-lg-1-5">
            <a class="link-cardly" href="https://www.kdepot.com.tw/" title="光達騎士精品網" target="_blank">
              <img alt="光達騎士精品網" src="@/assets/site/sitemap-3.png" />
            </a>
          </div>

          <div class="item pure-u-1-2 pure-u-md-1-3 pure-u-lg-1-5">
            <a class="link-cardly" href="https://www.kymco.com.tw/customer" title="KYMCO 客服" target="_blank">
              <img alt="KYMCO 客服" src="@/assets/site/sitemap-4.png" />
            </a>
          </div>
          <div class="item pure-u-1-2 pure-u-md-1-3 pure-u-lg-1-5">
            <a class="link-cardly" href="https://www.kymco.com.tw/newsroom/recall/" title="召回改正公告" target="_blank">
              <img alt="召回改正公告" src="@/assets/site/sitemap-5.png" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="site-footer__menu" ref="menu">
      <div class="container">
        <slot name="menu"></slot>
      </div>
    </div>
    <div class="site-footer__copyright">
      <div class="container">
        <div class="site-terms">
          <div class="small-title">
            <a href="https://www.kymco.com.tw/termsOfUse">使用條款</a>
          </div>
          <div class="button-shape">環保署環境噪音政策宣導</div>
        </div>
        <div class="provider-remark pure-g">
          <ul class="pure-u-1-1">
            <li>
              為維護民眾居住生活品質及環境安寧，請配備有「運動/競技模式」等車輛(含跑車、大型重型機車)之車主，勿於市區及住宅區使用或行使急加速、拉轉速行為，而高輸出功率會製造噪音之車輛，亦請車主盡量避免於市區夜間21時至上午7時間行駛。
            </li>
            <li>行政院環境保護署、內政部警政署及公路監理機關將針對車主擾寧之行為及製造噪音之車輛加強取締，以維護民眾生活安寧。</li>
            <li>KYMCO車主請使用原廠零件，不要改裝非法元件，以免觸法受罰。</li>
          </ul>
          <hr />
          <p class="pure-u-1-1 pure-u-md-1-2">建議使用edge或Chrome瀏覽器，以達最佳瀏覽效果。</p>
          <p class="pure-u-1-1 pure-u-md-1-2">Copyright © {{ getYear }} KWANG YANG MOTOR CO., LTD. All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
    <openNewWindow :isopen="openHref.isOpen" :openhref="openHref.openHref" @close_modal="closeModal"></openNewWindow>
  </div>
</template>

<script>
import openNewWindow from '../ui/openNewWindow.vue'

export default {
  name: 'footer-menu',
  components: {
    openNewWindow,
  },
  data() {
    return {
      openHref: {
        isOpen: false,
        openHref: '',
      },
    }
  },
  mounted() {
    const vm = this

    // 控制md時頁尾漢堡選單
    $(this.$refs.menu).on('click', 'h3', function () {
      $(this).parent().toggleClass('open')
      $(this).parent().siblings().removeClass('open')
    })
    // 監聽所有外連到ionex官網的項目
    $('.footerMenu-checkHref').on('click', function (e) {
      e.preventDefault()
      e.stopPropagation()
      vm.isOpenFn()
    })
    $('.footerMenu-openNewWindow').on('click', function (e) {
      e.preventDefault()
      e.stopPropagation()
      ga('send', 'event', location.pathname, '汰舊換新查詢', '汰舊換新查詢')
      gtag('event', '汰舊換新查詢', {'event_category': location.pathname,'event_label': '汰舊換新查詢'});
      window.open(
        this.href,
        '汰舊換新查詢',
        'left=20,top=20,width=550,height=450,olbar=no,location=no,directories=no,status=no,history=no,resizable=0,scrollbars=0'
      )
    })
  },
  methods: {
    isOpenFn(href = 'https://www.ionex.com.tw/') {
      // 會與openNewWindow元件有關：打開訊息框
      this.openHref.isOpen = true
      this.openHref.openHref = href
    },
    closeModal(isOpenVlue) {
      // 會與openNewWindow元件有關：關掉訊息框
      this.openHref.isOpen = isOpenVlue
    },
  },
  computed: {
    // 頁尾版權年份
    getYear() {
      const NowDate = new Date()
      return NowDate.getFullYear() // 西元四位數
    },
  },
}
</script>

<style lang="stylus" scoped>
$colorTextDarkGrey = #9fa0a0

.site-footer
  font-family '微軟正黑體'
  background #F0EEEE
  display flex
  flex-direction column

.site-footer__sitemap
  order 1
  text-align center
  margin-top 60px
  margin-left -.5rem
  margin-right -.5rem
  @media (max-width 767px)
    order 2
    margin-top 20px
    margin-bottom 40px
  .item
    padding .5rem
    img
      max-width 100%
      width 100% // IE11 跑版BUG
      height auto
      box-shadow 0px 0px 15px rgba(170, 170, 170, .1)

.site-footer__menu
  order 2
  background #F0EEEE
  padding-top 2rem
  padding-bottom 2rem
  user-select none
  @media (max-width 767px)
    order 1
    background url('~@/assets/site/bg-grating-fade.png')
  .menu
    &__category
      position relative
      .fa
        display none
      h3
        color #999
        font-weight bold
      a
        display block
        line-height 1.5
        font-size 1rem
        font-weight bold
        padding .25em 0
      @media (max-width 767px)
        background white
        color #666
        width 100%
        outline 1px solid #CCC
        padding 0
        a, h3
          border-top 1px solid #CCC
          padding .5rem 1rem
          display flex
          height 3rem
          align-items center
        h3
          color #333
          border none
          cursor pointer
          margin 0
        a
          background #F0F0F0
          padding-left 2rem
        .fa
          position absolute
          display inline-block
          right 1rem
          top 1rem
          pointer-events none
        &.open .fa.fa-chevron-down
          display none
        &:not(.open)
          a
            display none
          .fa.fa-chevron-up
            display none

.site-footer__copyright
  order 3
  font-family '微軟正黑體'
  background #252527
  color $colorTextDarkGrey
  padding 2em
  user-select none
  .site-terms
    text-align center
    padding 1em
    .small-title
      font-size 1.2em
      font-weight bold
      margin-bottom 1em
      a
        color #9fa0a0
  .provider-remark
    padding 1em 0
    text-align justify
    ul
      padding-left 2em
      li
        list-style-type  disc
        font-size 1.2em
        padding 0.5em 0em
    p
      font-size .875em
      line-height 1.8
      margin-top 2em
      @media (max-width 767px)
        margin-top 0em
    p:first-of-type
      @media (max-width 767px)
        margin-top 2em
    p:last-of-type
      text-align right
      @media (max-width 767px)
        text-align left
    hr
      width 100%
      margin-top 2em
      border none
      border-bottom 1px solid #9fa0a0

.button-shape
  overflow hidden
  white-space nowrap
  text-overflow ellipsis
  vertical-align middle
  box-sizing border-box
  display inline-block
  border-radius .25rem
  font-size 1.2rem !important
  line-height 1.5rem
  padding .536rem 1rem
  height 36px
  box-shadow 0 0 0 1px $colorTextDarkGrey inset
</style>
